import React from 'react';
import { useTranslate } from 'core/translate';
import Radio from 'core/controls/radio/Radio';
import OptionLinks from '../../optionLinks/OptionLinks';
import HighlightWithDisclaimer from '../../priceWithDisclaimer/HighlightWithDisclaimer';
import StandardFeatures from '../StandardFeatures';

const TrimOption = ({
  trim,
  option,
  checked,
  cardIndex,
  displayOnlyLabel,
  analyticsKey,
  highlight,
  isFiltered = false,
  isEvMode,
}) => {
  const {
    trimName,
    compareAll,
    trimDetails,
    lateAvailabilityDisclaimer,
  } = trim;
  const { driveTypeLabel, styleId } = option;
  const translate = useTranslate();

  const highlightDescription = highlight?.description;
  const highlightDisclaimer = highlight?.disclaimer;

  const displayDriveType = displayOnlyLabel
    ? translate('drive.type.only.v3', { driveType: driveTypeLabel })
    : driveTypeLabel;

  const detailsLink = trimDetails
    ? {
        link: `features/${styleId}${isFiltered ? '?isFiltered=true' : ''}`,
        label: 'body.detail.link.v3',
        analyticsKey: `${analyticsKey}:${trimName} ${displayDriveType}`,
        svg: 'info',
      }
    : null;
  const compareLink = compareAll
    ? {
        link: `compare?selectedIndex=${cardIndex}`,
        label: 'body.compare.link.v3',
        analyticsKey: `${analyticsKey}:${trimName} ${displayDriveType}`,
        svg: 'compare',
      }
    : null;

  const bodyLinks = [detailsLink, compareLink].filter((x) => x);

  const onClick = (event) => {
    event.preventDefault();
  };

  return (
    <div
      className="trim-option__container trim-option__container--full-height"
      onClick={onClick}>
      <Radio
        className="trim__drive-selector control--top"
        id={`trim-option__${cardIndex}`}
        checked={checked}
        analyticsKey={analyticsKey}>
        <div>
          <span className="option__trim-name">{trimName}</span>
          <span
            className={
              displayOnlyLabel
                ? 'option__drive-type--only'
                : 'option__drive-type'
            }>
            {displayDriveType}
          </span>
        </div>
      </Radio>
      {lateAvailabilityDisclaimer && (
        <span className="trim-option__late-availability-disclaimer">
          {lateAvailabilityDisclaimer}
        </span>
      )}
      {highlightDescription && (
        <HighlightWithDisclaimer
          className="trim__consumer-description"
          value="includes.description.v3"
          description={
            highlightDescription.length > 62
              ? `${highlightDescription.substring(0, 62)}&hellip;`
              : highlightDescription
          }
          disclaimer={highlightDisclaimer}
          useModal
        />
      )}
      {isEvMode && <StandardFeatures styleId={styleId} />}
      <OptionLinks
        className="option-links-container--bottom"
        options={{ bodyLinks }}
      />
    </div>
  );
};

export default TrimOption;
